import script from "./Groups.vue?vue&type=script&setup=true&lang=js"
export * from "./Groups.vue?vue&type=script&setup=true&lang=js"

import "./Groups.vue?vue&type=style&index=0&id=7347baa0&scoped=true&lang=css"

import exportComponent from "/home/toor/projects/fc/formacloud-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7347baa0"]])

export default __exports__